import {
  Avatar,
  Box,
  Button,
  FormControlLabel,
  Menu,
  MenuItem,
  Switch,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { viewImage } from "../../utils/viewPDF";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useOrganization } from "../../utils/OrganizationContext";
import NotificationAccess from "../../utils/NotificationAccess";
import { LeadSearch, NewMenu, PlanBadge } from "../../utils/NavbarTools";
import ErrorModal from "../../utils/ErrorModal";

// Direction C tokens
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const MUTED = "#66748A";
const LINE = "#E4E9EF";
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const NEW_GROUPS = [
  { title: "Work", items: [
    { label: "Lead", path: "/dashboard/add-lead" },
    { label: "Reminder", path: "/dashboard/reminder/add-reminder" },
    { label: "Inventory", path: "/dashboard/inventory/add-inventory" },
  ] },
  { title: "Setup", items: [
    { label: "Project", path: "/dashboard/create-project" },
    { label: "User", path: "/dashboard/create-user" },
    { label: "Team", path: "/dashboard/create-team" },
    { label: "Partner", path: "/dashboard/add-partner" },
    { label: "Lead structure", path: "/dashboard/create-structure" },
  ] },
];

const AdminNavbar = () => {
  const [org, setOrg] = useState();
  const [fileUrl, setFileUrl] = useState("");
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 750px)");
  const { orgId, changeOrganization } = useOrganization();
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState(
    JSON.parse(localStorage.getItem("org")) || "",
  );

  const [subEndedOpen, setSubEndedOpen] = useState(false);
  const handleSubEndedClose = () => {
    setSubEndedOpen(false);
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user/get-all-org?username=${storedUser.username}`,
          {
            headers: {
              Authorization: `Bearer ${storedUser.accessToken}`,
            },
          },
        );

        setOrganizations(res.data);

        let orgId = JSON.parse(localStorage.getItem("org"));

        if (!orgId && res.data.length > 0) {
          orgId = res.data[0].orgId;
          localStorage.setItem("org", JSON.stringify(orgId));
        }

        setSelectedOrgId(orgId);
      } catch (err) {
        console.log(err);
      }
    };

    fetchOrganizations();
  }, []);

  useEffect(() => {
    const getOrg = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}&orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setOrg(res.data);
        localStorage.setItem(
          "name",
          JSON.stringify(res.data?.adminName || "Name"),
        );
        localStorage.setItem("org", JSON.stringify(res.data?.orgId));
        localStorage.setItem("subs", JSON.stringify(res.data?.subscription));

        // Org logo is hidden in the navbar, so it is no longer fetched here
        // (the failed fetch was showing an error on every page).
        // if (res.data.orgLogo) {
        //   const url = await viewImage(res.data.orgLogo, storedUser);
        //   setFileUrl(url);
        // }

        if (
          res.data.subscription !== "FREE" &&
          res.data.subscriptionEndDate < new Date().toISOString().split("T")[0]
        ) {
          setSubEndedOpen(true);
          return;
        }
      } catch (error) {
        console.error("Error fetching organization:", error);
        navigate("/");
        localStorage.clear();
      }
    };
    getOrg();
    // After a successful payment the result page fires "plan-changed" → re-read the org (badge updates).
    window.addEventListener("plan-changed", getOrg);
    return () => window.removeEventListener("plan-changed", getOrg);
  }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        borderBottom: `1px solid ${LINE}`,
        position: "sticky",
        top: 0,
        zIndex: 20,
        fontFamily: FONT,
        color: INK,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          minHeight: 56,
          pl: isMobile ? 7 : 3,
          pr: isMobile ? 2 : 3,
          py: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            minWidth: 0,
          }}
        >
          {/* Organization logo hidden — showed a broken-image placeholder.
          {org?.orgLogo && (
            <img
              src={fileUrl && fileUrl}
              alt="Organization Logo"
              style={{
                height: 32,
                width: "auto",
                borderRadius: 8,
                objectFit: "contain",
                flexShrink: 0,
              }}
            />
          )} */}
          <Box
            component="p"
            sx={{
              m: 0,
              display: "inline-flex",
              alignItems: "center",
              height: 30,
              px: 1.5,
              minWidth: 0,
              maxWidth: isMobile ? 180 : 320,
              background: "#EAF2FB",
              border: "1px solid #C9DEF3",
              borderRadius: "999px",
              color: "#1B4F82",
              fontFamily: FONT,
              fontSize: 13,
              fontWeight: 600,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              gap: 0.75,
            }}
          >
            <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{org?.orgName}</span>
            <PlanBadge plan={org?.subscription} />
          </Box>
        </Box>

        {!isMobile && (
          <LeadSearch
            orgId={org?.orgId || JSON.parse(localStorage.getItem("org"))}
            projectId={JSON.parse(localStorage.getItem("projectId") || "null")}
            token={JSON.parse(localStorage.getItem("user"))?.accessToken}
          />
        )}
        <Box sx={{ display: "flex", alignItems: "center", columnGap: 1.5, flexShrink: 0 }}>
          <NewMenu groups={NEW_GROUPS} />
          {/* {!isMobile && (
            <Button
              className="btn-outlined"
              sx={{
                padding: "5px 60px !important",
                border: "1px solid #1a71f6",
              }}
              onClick={() => navigate("/dashboard")}
            >
              Dashboard
            </Button>
          )} */}
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1.25,
              fontFamily: FONT,
              fontSize: 13.5,
              fontWeight: 600,
              color: INK,
              whiteSpace: "nowrap",
            }}
          >
            {!isMobile && (org?.adminName || "Name")}
            <Avatar
              {...stringAvatar(`${org?.adminName || "Name"}`)}
              onClick={handleAvatarClick}
              sx={{
                cursor: "pointer",
                width: 32,
                height: 32,
                background: INK,
                color: "#FFFFFF",
                fontFamily: MONO,
                fontSize: 11.5,
                fontWeight: 600,
                transition: "box-shadow .15s",
                boxShadow: open ? "0 0 0 3px #C9DEF3" : "none",
                "&:hover": { boxShadow: "0 0 0 3px #EAF2FB" },
              }}
            />
            {/* <NotificationsNoneIcon /> */}
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPaper-root": {
                  mt: 1,
                  minWidth: 240,
                  borderRadius: "12px",
                  border: `1px solid ${LINE}`,
                  boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
                },
                "& .MuiList-root": { p: 0.75 },
                "& .MuiMenuItem-root": {
                  fontFamily: FONT,
                  fontSize: 13.5,
                  fontWeight: 500,
                  color: INK_2,
                  borderRadius: "8px",
                  minHeight: 36,
                  px: 1.25,
                  "&:hover": { background: "#F4F7FA", color: INK },
                },
                "& .MuiMenuItem-root.Mui-selected": {
                  background: "#EAF2FB",
                  color: "#1B4F82",
                  fontWeight: 700,
                  "&:hover": { background: "#DCEAF8" },
                },
              }}
            >
              {/* {isMobile && (
                <MenuItem onClick={() => navigate("/dashboard")}>
                  Dashboard
                </MenuItem>
              )} */}
              <MenuItem>
                <NotificationAccess
                  orgIds={organizations.map((item) => item.orgId)}
                  variant="menu"
                />
              </MenuItem>
              {organizations.length > 0 && (
                <>
                  <MenuItem
                    disabled
                    sx={{
                      "&.Mui-disabled": { opacity: 1 },
                      minHeight: "28px !important",
                      mt: 0.5,
                      borderTop: `1px solid #EDF1F5`,
                      borderRadius: "0 !important",
                      pt: 1.25,
                      "& strong": {
                        fontFamily: MONO,
                        fontSize: 10,
                        fontWeight: 500,
                        letterSpacing: "0.11em",
                        textTransform: "uppercase",
                        color: "#7B8A9C",
                      },
                    }}
                  >
                    <strong>My Organizations</strong>
                  </MenuItem>

                  {organizations.map((item) => (
                    <MenuItem
                      key={item.orgId}
                      selected={item.orgId === selectedOrgId}
                      onClick={async () => {
                        setSelectedOrgId(item.orgId);
                        await changeOrganization(item.orgId);
                        localStorage.removeItem("projectId");
                        navigate("/dashboard");
                        handleClose();
                      }}
                    >
                      {item.orgName}
                    </MenuItem>
                  ))}
                </>
              )}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  mt: 0.5,
                  borderTop: `1px solid #EDF1F5`,
                  color: "#A6342A !important",
                  fontWeight: "700 !important",
                  "&:hover": { background: "#FBEDEB !important" },
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>

      <ErrorModal
        open={subEndedOpen}
        handleClose={handleSubEndedClose}
        msg="Your organization's subscription has ended. Please contact the CRM."
        type="error"
      />
    </Box>
  );
};

export default AdminNavbar;